export const ConfigurationPage = () => {
  return <div>Настройка</div>
}
